import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Attachment } from '../../../../../../../core/interfaces/index';

@Component({
  selector: 'attachment',
  templateUrl: './attachment.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AttachmentComponent implements OnInit {

  private endsWithMP4 = new RegExp('\.mp4$');

  fileType: string;
  thumbnail: string;


  @Input() readonly attachment: Attachment;

  constructor() {
  }

  ngOnInit(): void {
    this.fileType = this.getFileType();
    this.thumbnail = this.getThumbnail();
  }

  getFileType(): string {
    const extension = this.getExtension().toLowerCase();

    if (extension === 'mp4') {
      return 'video';
    }

    if (['jpg', 'jpeg', 'png', 'jfif', 'heic', 'webp'].includes(extension)) {
      return 'image';
    }

    return 'other';

  }

  private getExtension(): string {
    const indexOfLastPoint = this.attachment.path.lastIndexOf('.');
    return this.attachment.path.substring(indexOfLastPoint + 1);
  }

  getThumbnail(): string {
    if (this.endsWithMP4.test(this.attachment.path)) {
      return this.attachment.path.replace(this.endsWithMP4, '.jpg');
    }
    return this.attachment.path;
  }

}
